import React, { useState, useEffect } from "react";
import axios from "axios";
import AqiTranslate from "./AqiTranslate";

export default function WeatherAqi(props) {
  const [ready, setReady] = useState(false);
  const [aqi, setAqi] = useState(null);
  useEffect(() => {
    setReady(false);
  }, [props.coordinates]);
  function HandleResponse(response) {
    console.log(response.data);
    setAqi(response.data.list[0].main.aqi);
    setReady(true);
  }
  if (ready) {
    return (
      <span>
        {aqi}{" "}
        <span>
          <AqiTranslate data={aqi} />
        </span>
      </span>
    );
  } else {
    let apiKey = "9d803c2f0a76ba74617914897fa4e1e7";
    let longitude = props.coordinates.lon;
    let latitude = props.coordinates.lat;
    let apiUrl = `https://api.openweathermap.org/data/2.5/air_pollution?lat=${latitude}&lon=${longitude}&units=metric&appid=${apiKey}`;
    axios.get(apiUrl).then(HandleResponse);
    return "aqi loading...";
  }
}
